// Maps keywords to actual app routes for help guide action buttons
export const routeMap: Record<string, string> = {
  "jobs": "/jobs",
  "job": "/jobs",
  "sales hub": "/sales-hub",
  "leads": "/sales-hub",
  "dashboard": "/dashboard",
  "calendar": "/calendar",
  "tasks": "/tasks",
  "bridgette": "/agent",
  "agent": "/agent",
  "estimates": "/estimates",
  "measurements": "/measurements",
  "analytics": "/analytics",
  "reports": "/reports",
  "settings": "/settings",
  "crew": "/crew",
  "catalog": "/catalog",
  "help": "/help",
};

export function detectActionRoute(text: string): string | null {
  const lowerText = text.toLowerCase();
  
  for (const [keyword, route] of Object.entries(routeMap)) {
    if (lowerText.includes(keyword)) {
      return route;
    }
  }
  
  return null;
}
